import {
    apiRequest,
    masterWorkUnit,
    Employee,
    lemburExport,
    lamakerjaExport,
    akumulasiperunitExport,
    izinperunitExport,
    izinperunitExport2,
    kehadiranPerorangExport,
    kehadiranPerunitExport,
    izinSTperunitExport,
    tidakhadirperunitExportAlpha,
    absensiPerunitExport,
    absensiPerorangExport
} from "../../../../../services/adapters/Laporan/masakerjaService"

class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchExport = async (query) => {
        return await apiRequest("get", lemburExport, {
            params: query
        }, true)
    }
    fetchExport_lamakerja = async (query) => {
        return await apiRequest("get", lamakerjaExport, {
            params: query
        }, true)
    }
    fetchExport_tdkhadirperunitAlpha = async (query) => {
        return await apiRequest("get", tidakhadirperunitExportAlpha, {
            params: query
        }, true)
    }
    fetchAkumulasiperunit = async (query) => {
        return await apiRequest("get", akumulasiperunitExport, {
            params: query
        }, true)
    }
    fetchIzinExport = async (query) => {
        return await apiRequest("get", izinperunitExport, {
            params: query
        }, true)
    }
    fetchIzinExport2 = async (query) => {//include hari libur dan tanggal merah
        return await apiRequest("get", izinperunitExport2, {
            params: query
        }, true)
    }
    fetchIzinSTExport = async (query) => {//include hari libur dan tanggal merah
        return await apiRequest("get", izinSTperunitExport, {
            params: query
        }, true)
    }
    fetchKehadiranPerorangExport = async (query) => {
        return await apiRequest("get", kehadiranPerorangExport, {
            params: query
        }, true)
    }
    fetchAbsensiPerorangExport = async (query) => {
        return await apiRequest("get", absensiPerorangExport, {
            params: query
        }, true)
    }
    fetchKehadiranPerUnitExport = async (query) => {
        return await apiRequest("get", kehadiranPerunitExport, {
            params: query
        }, true)
    }
    fetchAbsensiPerUnitExport = async (query) => {
        return await apiRequest("get", absensiPerunitExport, {
            params: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", Employee, {
            params: query
        }, true)
    }
}

export default IndexRepository